import React, { useEffect } from "react";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import { TextareaAutosize, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API } from "../../backend";
import { getAllCategoriesUnderParent } from "../../helper/categoryApiCalls/category";

const style = {
  width: "100%",
  maxWidth: "100vw",
  position: "fixed",
  top: "50%",
  left: "0",
  transform: "translate(0, -50%)",
  overflowY: "auto",
};

const useStyles = makeStyles((theme) => ({
  input: {
    width: "100%",
    margin: "10px 0",
    outline: "none",
    color: "var(--text-primary)",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--text-primary) !important",
    },
    "& .MuiInputLabel-root": {
      color: "var(--text-primary) !important",
    },
    "& .MuiInputBase-input": {
      color: "var(--text-primary) !important",
    },
  },
  formControl: {
    margin: "10px 0",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--text-primary) !important",
    },
    "& .MuiInputLabel-root": {
      color: "var(--text-primary) !important",
    },
    "& .MuiSelect-icon": {
      color: "var(--text-primary) !important",
    },
    "& .MuiSelect-select": {
      color: "var(--text-primary) !important",
    },
  },
  text: {
    fontSize: "14px",
    margin: 2,
  },
  menu: {
    width: "100%",
  },
  add: {
    fontSize: "17px",
    marginLeft: "10px",
    fontWeight: "600",
    backgroundClip: "border-box",
    background: "-webkit-linear-gradient(#4a1d85, #156fbc)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    cursor: "pointer",
    border: "none",
  },
  box: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowY: "scroll",
    height: "150px",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
  },
  links: {
    fontSize: "14px",
    display: "block",
    margin: "10px 0",
    outline: "none",
    border: "none",
    width: "100%",
    color: "var(--text-primary)",
    background: "transparent",
    cursor: "text",
  },
  button: {
    float: "right",
    margin: "30px",
    padding: "10px 20px",
    background: "linear-gradient(92.12deg, #4a1d85 1.79%, #156fbc 99.22%)",
    color: "white",
    cursor: "pointer",
    fontSize: "16px",
    border: "none",
  },
  title: {
    fontSize: "20px",
    fontWeight: "600",
    backgroundClip: "border-box",
    background: "-webkit-linear-gradient(#4a1d85, #156fbc)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    border: "none",
  },
  error: {
    color: "red",
    fontSize: "13px",
    marginTop: "10px",
    fontWeight: "600",
  },
  success: {
    color: "green",
    fontSize: "14px",
    marginTop: "10px",
    fontWeight: "600",
  },
  linkContainer: {
    display: "flex",
    // alignItems: "",
    width: "100%",
    justifyContent: "space-between",
    borderBottom: "1px solid #e6e6e6",
  },
  delbtn: {
    fontSize: "20px",
    color: "red",
    fontWeight: "600",
    border: "none",
    outline: "none",
    background: "transparent",
    cursor: "pointer",
  },
  modal: {
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "6px",
      backgroundColor: "lightgray",
    },
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    height: "700px",
    background: "var(--bg-secondary)",
    padding: "40px",
    outline: "none",
  },
  textarea: {
    width: "100%",
    margin: "10px 0",
    resize: "none",
    height: "150px",
    overflowY: "scroll",
    outline: "none",
    "&:focus": {
      outline: "1px solid #139ded",
      borderRadius: "5px",
    },
    padding: "10px",
    border: "0.5px solid var(--text-primary)",
    borderRadius: "5px",
    boxShadow: "1px 1px 1px 1px var(--text-secondary)",
    fontSize: "14px",
    color: "var(--text-primary)",
    background: "transparent",
    lineHeight: "1.5",
  },
  upload: {
    textAlign: "center",
    fontFamily: "Epilogue",
    fontSize: "21px",
    fontWeight: 700,
    lineHeight: "22px",
  },
  back: {
    float: "left",
    margin: "30px 0",
    padding: "10px 20px",
    color: "var(--text-primary)",
    cursor: "pointer",
    fontSize: "16px",
    border: "none",
  },
}));

function UploadVideos({ open, setOpen }) {
  //   const handleOpen = () => setOpen(true);

  const [categories, setCategories] = React.useState([]);
  const [subcategories, setSubcategories] = React.useState([]);

  const [category, setCategory] = React.useState(null);
  const [subCategory, setSubCategory] = React.useState(null);
  const [videoList, setVideoList] = React.useState([]);
  const [videoName, setVideoName] = React.useState("");

  const [desc, setDesc] = React.useState({
    name: "",
    description: "",
    language: "",
  });

  const [branchCategory, setBranchCategory] = React.useState([]);
  const [success, setSuccess] = React.useState(false);
  const [error, setError] = React.useState("");
  const [detailError, setDetailError] = React.useState("");
  const [selectedBrach, setSelectedBranch] = React.useState([]);

  const [detail, setDetail] = React.useState([]);

  const handleDesc = (e) => {
    setDesc({ ...desc, [e.target.name]: e.target.value });
  };

  const handleClose = () => setOpen(false);
  // let categories = [];
  // let subcategories = [];
  const classes = useStyles();

  async function handleCategory(event) {
    if (event.target.value) {
      const response = await getAllCategoriesUnderParent(event.target.value);
      if (response) {
        let newArr = [...branchCategory];
        let object = {
          index: 0,
          subCategories: response.data,
        };

        if (newArr.length === 0) {
          await newArr.push(object);
        } else {
          newArr = [];
          newArr.push(object);
        }

        setBranchCategory(newArr);
        setSelectedBranch([event.target.value]);
      }
    }
  }

  async function handleSubCat(e, index) {
    if (e.target.value) {
      const response = await getAllCategoriesUnderParent(e.target.value);

      if (response && response.data.length > 0) {
        let newArr = await branchCategory;

        let object = {
          index: index + 1,
          subCategories: response.data,
        };

        await newArr.push(object);

        await setBranchCategory(newArr);
      }
      if (selectedBrach.length > 0 && !selectedBrach[index + 1]) {
        setSelectedBranch((selectedBrach) => [
          ...selectedBrach,
          e.target.value,
        ]);
      } else {
        let otherBranch = [...selectedBrach];
        await otherBranch.splice(index + 1, otherBranch.length - (index + 1));

        let newOtherBranch = [...otherBranch];
        await newOtherBranch.push(e.target.value);
        await setSelectedBranch(newOtherBranch);

        if ([...branchCategory].length >= newOtherBranch.length) {
          let newupdatedBranchCat = await [...branchCategory].splice(
            index + 1,
            [...branchCategory].length - (index + 1),
          );

          let newupdatedArray = await [...branchCategory].filter(
            (n) => !newupdatedBranchCat.includes(n),
          );

          if (response && response.data.length > 0) {
            let object = {
              index: index + 1,
              subCategories: response.data,
            };
            await newupdatedArray.push(object);
            await setBranchCategory(newupdatedArray);
          } else {
            await setBranchCategory(newupdatedArray);
          }
        }
      }
    }
  }

  async function handleAdd(e) {
    e.preventDefault();
    if (videoName === "") {
      return;
    }

    setVideoList([...videoList, videoName]);

    let YT_url =
      "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=";
    const key = "&key=AIzaSyDIcBfTRXG5W4G4QzzlkBDSN6W9Y3RXjQM";

    YT_url += videoName.slice(17);

    // YT_url += "%2C" + vids[i].slice(17);

    YT_url = (await YT_url) + key;
    const config = {
      method: "get",
      url: YT_url,
    };

    const result = await axios(config);

    let newResult = Object.assign(result?.data?.items[0], {
      videoName: videoName,
    });

    if (result.data.items.length !== 0) {
      await setDetail((prevArray) => [...prevArray, newResult]);
    }

    setVideoName("");
  }

  const checkLink = async (link) => {
    let check;
    if (videoList.includes(link)) {
      setError("Video already exists");
      setVideoName("");
    } else if (link !== "") {
      check = await youtube_parser(link);
      if (check === false) {
        check = link;
        setError("Invalid link ");
        setVideoName("");
      }
    } else {
      setError("");
    }

    // return true;
    // setError("");
    setVideoName(check);
  };

  async function youtube_parser(url) {
    var regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = await url.match(regExp);
    return match && match[7].length === 11
      ? `https://youtu.be/${match[7]}`
      : false;
  }

  const removeVideo = (v) => {
    // e.preventDefault();

    const newList = videoList.filter((video) => video !== v);

    let newDetail = detail.filter((video) => video.videoName !== v);

    setDetail(newDetail);

    setVideoList(newList);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    var config = {
      method: "get",
      url: `${API}/category/getAll`,
      headers: {},
    };

    const data = await axios(config);

    setCategories(data.data.data);
  }, []);

  const UploadList = () => {
    if (videoList.length < 5) {
      setDetailError("Please add atleast 5 videos");
      return;
    } else if (desc.name < 3 || desc.description < 8 || desc.language < 3) {
      setDetailError("Name or Description or Language not long enough");
      return;
    }

    if (detail && detail.length > 0) {
      let videoDeatils = [];

      for (let i = 0; i < detail.length; i++) {
        let object = {
          videoName: detail[i].videoName,
          title: detail[i].snippet.title,
          description: detail[i].snippet.description,
          thumbnail: detail[i].snippet.thumbnails.high.url,
          publishedAt: detail[i].snippet.publishedAt,
          language: desc.language,
        };
        videoDeatils.push(object);
      }

      var data = {
        name: desc.name,
        description: desc.description,
        language: desc.language,
        category: selectedBrach,

        videos: videoDeatils,
      };

      var config = {
        method: "post",
        url: `${API}/playlist/create`,
        headers: {
          Authorization: `Bearer ${JSON.parse(
            localStorage.getItem("_access_token"),
          )}`,
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response?.data?.status === "success") {
            setSuccess(true);
            toast("Playlist Uploaded Successfully");
          }

          // setOpen(false);

          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const names = [
    "English",
    "Hindi",
    "Marathi",
    "Konkani",
    "Bengali",
    "Tamil",
    "Kannada",
    "German",
    "Chinese",
    "Telugu",
  ];

  let width = window.innerWidth;

  return (
    <>
      {success && <ToastContainer />}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={width < 768 ? style : null} className={classes.modal}>
            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              sx={{ my: 1 }}
              className={classes.upload}
            >
              Upload Your Videos
            </Typography>

            <TextField
              id="outlined-basic"
              label="Topic"
              name="name"
              className={classes.input}
              autoComplete="off"
              sx={{ my: 2 }}
              onChange={(e) => handleDesc(e)}
            />
            <TextareaAutosize
              aria-label="maximum height"
              label="Description"
              name="description"
              placeholder="Description"
              sx={{ my: 2 }}
              className={classes.textarea}
              onChange={(e) => handleDesc(e)}
            />
            <FormControl fullWidth className={classes.formControl}>
              <InputLabel id="demo-simple-select-label">Language</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="language"
                value={desc.language}
                label="Language"
                onChange={(e) => handleDesc(e)}
              >
                {names.map((lang, index) => {
                  return <MenuItem value={lang.toLowerCase()}>{lang}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              sx={{ my: 2 }}
              className={classes.formControl}
            >
              <InputLabel id="demo-simple-select-label">Category</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedBrach[0]}
                placeholder="Select Category"
                label="Category"
                onChange={handleCategory}
              >
                {categories.map((cat) => (
                  <MenuItem className={classes.menu} value={cat?._id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {branchCategory &&
              branchCategory.length > 0 &&
              branchCategory.map((bra, index) => {
                return (
                  <FormControl
                    fullWidth
                    sx={{ my: 2 }}
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-simple-select-label">
                      Sub-Category {index + 1}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedBrach[index + 1]}
                      label="Sub-Category"
                      placeholder="Sub-Category"
                      onChange={(e) => handleSubCat(e, index, bra.index)}
                    >
                      {bra?.subCategories?.length > 0 &&
                        bra?.subCategories?.map((cat) => {
                          return (
                            <MenuItem className={classes.menu} value={cat._id}>
                              {cat.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                );
              })}

            {detailError && (
              <Typography
                variant="h6"
                id="transition-modal-title"
                className={classes.error}
                style={{ color: "red" }}
              >
                * {detailError}
              </Typography>
            )}

            <Typography
              id="transition-modal-title"
              variant="h6"
              component="h2"
              className={classes.title}
            >
              Add Video Url's From Youtube
            </Typography>
            <Box className={classes.text}>
              {error && (
                <Typography
                  variant="h6"
                  id="transition-modal-title"
                  className={classes.error}
                >
                  * {error}
                </Typography>
              )}
              {videoList.length > 0 && (
                <Typography
                  variant="h6"
                  id="transition-modal-title"
                  className={classes.success}
                >
                  {videoList.length} videos added
                </Typography>
              )}
              {videoList.length === 0 ? (
                <Typography
                  variant="h6"
                  id="transition-modal-title"
                  className={classes.success}
                >
                  {videoList.length} videos added
                </Typography>
              ) : (
                <Box className={classes.list}>
                  {videoList.map((video, index) => (
                    <div className={classes.linkContainer}>
                      <input className={classes.links} value={video} readOnly />
                      <button
                        className={classes.delbtn}
                        onClick={() => removeVideo(video)}
                      >
                        x
                      </button>
                    </div>
                  ))}
                </Box>
              )}
            </Box>
            <Box className={classes.box}>
              <TextField
                id="outlined-basic"
                label=""
                placeholder="Add new URLs"
                value={videoName}
                onChange={(e) => checkLink(e.target.value)}
                className={classes.input}
              />
              <button
                className={classes.add}
                onClick={handleAdd}
                disabled={error}
              >
                Add
              </button>
            </Box>
            <button className={classes.button} onClick={UploadList}>
              Upload
            </button>
            <button className={classes.back} onClick={() => setOpen(false)}>
              Back
            </button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default UploadVideos;
